import { NgClass } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { DPFormField } from 'src/app/core/models/DPFormField';
import { KeyValue } from 'src/app/core/models/KeyValue';

/**
 * Dropdown component.
 * 
 * This is a single select dropdown component.
 * 
 * If field.optionKeyOnly is true,
 * the value is just key of selected option. 
 *
 * If field.optionKeyOnly is false,
 * the value is a JSON string of following object:
 *  { "selected option key": "selected option value" }
 */
@Component({
  selector: 'app-dropdown',
  standalone: true,
  imports: [NgClass, ReactiveFormsModule],
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss'],
})
export class DropdownComponent implements OnInit {
  @Input() field: DPFormField;
  @Input() control: UntypedFormControl;
  @Input() disabled: boolean;

  options: KeyValue[] = [];

  constructor() {}

  /**
   * Popuplate options from field.
   */
  ngOnInit(): void {
    this.options = (this.field.options || []).map((opt) => ({
      key: this.field.optionKeyOnly
        ? opt.key
        : JSON.stringify({ [opt.key]: opt.value }),
      value: opt.value,
    }));
  }
}
